import React from 'react';

/**
 * Quiet "почему оно попало в выборку" hint under the description.
 *
 * Color was overpowering on long lists, so we only surface:
 * - matched query words (in monospace «word» form), for textual methods
 * - matched trademark, when trademark methods fired and there's a trademark
 *
 * Method names themselves no longer get coloured pills here — that
 * information is already available in the DetailPanel on click.
 */

const TEXTUAL_METHODS = new Set([
  'fulltext', 'trigram', 'ilike', 'ilike_description', 'semantic',
]);

function findMatchedWords(query, description) {
  if (!query || !description) return [];
  const words = query.split(/\s+/).filter(w => w.length > 1);
  const descLower = description.toLowerCase();
  const seen = new Set();
  const out = [];
  for (const w of words) {
    const key = w.toLowerCase();
    if (seen.has(key)) continue;
    if (descLower.includes(key)) {
      seen.add(key);
      out.push(w);
    }
  }
  return out;
}

export default function MatchBadges({ searchMethod, searchQuery, row }) {
  if (!searchMethod) return null;

  const methods = searchMethod.split(/,\s*/).map(s => s.trim().toLowerCase());
  const isTextual = methods.some(m => TEXTUAL_METHODS.has(m));
  const isTrademark = methods.some(m => m.includes('trademark'));

  const matchedWords = isTextual
    ? findMatchedWords(searchQuery, row.product_description_original).slice(0, 3)
    : [];
  const trademark = isTrademark ? row.trademark?.trim() : '';

  if (matchedWords.length === 0 && !trademark) return null;

  return (
    <div className="flex flex-wrap items-center gap-x-1.5 gap-y-0.5 mt-1 text-[10px] text-text-muted">
      {matchedWords.map((word, i) => (
        <span key={`w-${i}`} className="font-mono">«{word}»</span>
      ))}
      {trademark && (
        <span
          className="font-medium text-text-secondary"
          title="Совпадение по торговой марке"
        >
          {trademark.length > 18 ? trademark.slice(0, 18) + '…' : trademark}
        </span>
      )}
    </div>
  );
}
